if (!customElements.get('look-gallery-product')) {
  customElements.define(
    'look-gallery-product',
    class LookGalleryProduct extends HTMLElement {
      constructor() {
        super();
        this.variantSelect = this.querySelector('.look-gallery-product__select');
        this.price = this.querySelector('[data-look-product-price]');
        this.updatePrice = this.updatePrice.bind(this);
      }

      connectedCallback() {
        this.variantSelect?.addEventListener('change', this.updatePrice);
      }

      disconnectedCallback() {
        this.variantSelect?.removeEventListener('change', this.updatePrice);
      }

      updatePrice() {
        const selectedVariant = this.variantSelect?.selectedOptions[0];

        if (selectedVariant?.dataset.price && this.price) {
          this.price.textContent = selectedVariant.dataset.price;
        }
      }
    }
  );
}
